import { api } from '../lib/client';

const DEFAULT_PAGE_SIZE = 200;

// Walk the {users, next} cursor so callers get the full filtered list.
export async function fetchUsers({ search, status, limit = DEFAULT_PAGE_SIZE, offset = 0 } = {}) {
  const items = [];
  let nextOffset = offset;
  do {
    const params = { limit, offset: nextOffset };
    if (search) params.search = search;
    if (status) params.status = status;
    const { data } = await api.get('/users', { params });
    items.push(...(data.users || []));
    nextOffset = data.next === false || data.next == null ? null : data.next;
  } while (nextOffset != null);
  return items;
}

export async function fetchOrganisations() {
  const { data } = await api.get('/organisations');
  return data?.organisations || [];
}

// `patch` may contain any subset of { name, status, agentLimit, role,
// permissions, allowedModels, organisationId }. role is now a STRING.
export async function updateUser(userId, patch) {
  const { data } = await api.patch(`/users/${encodeURIComponent(userId)}`, patch);
  return data;
}

// The caller's own identity + resolved RBAC view: { role, organisationId,
// permissions, allowedModels, isAdmin, isSuperAdmin, assignableRoles }.
// null when not authenticated / backend unavailable (treated as non-admin).
export async function fetchMe() {
  try {
    const { data } = await api.get('/me');
    return data;
  } catch {
    return null;
  }
}

// `patch` may contain any subset of { name, status, agentLimit, role,
// permissions, allowedModels }. role/permissions/allowedModels are super-admin only.
export async function updateOrganisation(orgId, patch) {
  const { data } = await api.patch(`/organisations/${encodeURIComponent(orgId)}`, patch);
  return data;
}

export async function createOrganisation(payload) {
  const { data } = await api.post('/organisations', payload);
  return data;
}

// Soft-deactivate an organisation (super-admin only): sets status='deactivated',
// so its members lose access until reactivated. Never hard-deletes (orgs cascade
// to users/agents).
export async function deleteOrganisation(orgId) {
  const { data } = await api.delete(`/organisations/${encodeURIComponent(orgId)}`);
  return data;
}
